module.exports = __webpack_public_path__ + "static/media/chrome-copy.74ebb73e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chrome-copy.png
// module id = 1221
// module chunks = 0